import axios from "axios";

const AUTH_ERROR_CODES = [
    "ACCOUNT_DISABLED",
    "TOKEN_REVOKED",
];

const authResponseInterceptor = (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;

    const code =
        data?.code ||
        data?.error?.code;

    if (
        status === 401 &&
        AUTH_ERROR_CODES.includes(code)
    ) {
        window.dispatchEvent(
            new CustomEvent("app:force-logout", {
                detail: {
                    reason: code,
                    message:
                        data?.message ||
                        "Your session is no longer valid. Please log in again.",
                },
            })
        );
    }

    return Promise.reject(error);
};

export const setupAuthInterceptor = () => {
    const interceptorId = axios.interceptors.response.use(
        (response) => response,
        authResponseInterceptor
    );

    return () => {
        axios.interceptors.response.eject(interceptorId);
    };
};
